/* eslint-disable max-lines */
import PiperQuiz from './piperquiz.js';
import ko from 'knockout';

const data = {
    sections: [
        {
            name: 'Piper_Home',
            response: 'Home',
            result: false,
            question:
                '<div class="header">Not sure which Piper or Hadley Breeches are right for you? Answer a few quick questions and we\'ll match you with your perfect pair!<br>Let\'s get started!</div><br>Are you looking for girls or ladies breeches?',
            answer: [
                {
                    response: 'Girls',
                    link: '#Girls',
                    image: ''
                },
                {
                    response: 'Ladies',
                    link: '#Ladies',
                    image: ''
                }
            ],
            productId: '',
            showSection: 'sectionName'
        },
        {
            name: 'Piper_Girls',
            response: 'Girls',
            result: true,
            question: '',
            answer: [],
            productId: '24956!24990!25569',
            showSection: 'sectionName jsHide'
        },
        {
            name: 'Piper_Ladies',
            response: 'Ladies',
            result: false,
            question: 'Do you prefer full seat, knee patch or boot cut breeches?',
            answer: [
                {
                    response: 'Full Seat',
                    link: '#Full_Seat',
                    image: ''
                },
                {
                    response: 'Knee Patch',
                    link: '#Knee_Patch',
                    image: ''
                },
                {
                    response: 'Boot Cut',
                    link: '#Boot_Cut',
                    image: ''
                }
            ],
            productId: '',
            showSection: 'sectionName jsHide'
        },
        {
            name: 'Piper_Full_Seat',
            response: 'Full Seat',
            result: false,
            question: 'Are you looking for schooling breeches or showing breeches?',
            answer: [
                {
                    response: 'Schooling',
                    link: '#Full_Seat_Schooling',
                    image: ''
                },
                {
                    response: 'Showing',
                    link: '#Full_Seat_Showing',
                    image: ''
                }
            ],
            productId: '',
            showSection: 'sectionName jsHide'
        },
        {
            name: 'Piper_Full_Seat_Showing',
            response: 'Showing',
            result: false,
            question:
                'Do you prefer the classic look and feel of a traditional woven material or the performance of a technical fabric?',
            answer: [
                {
                    response: 'Traditional Woven',
                    link: '#Full_Seat_Showing_Woven',
                    image: '/images/PiperQuiz/answer_4b.jpg'
                },
                {
                    response: 'Technical',
                    link: '#Full_Seat_Showing_Technical',
                    image: '/images/PiperQuiz/technical.jpg'
                }
            ],
            productId: '',
            showSection: 'sectionName jsHide'
        },
        {
            name: 'Piper_Full_Seat_Showing_Woven',
            response: 'Woven',
            result: false,
            question:
                'Do you prefer a low-rise fit that hits below the belly button, a mid-rise fit that hits at the belly button, or a high-rise fit that hits at the natural waist?',
            answer: [
                {
                    response: 'Low-Rise',
                    link: '#Full_Seat_Showing_Woven_Low_Rise',
                    image: '/images/PiperQuiz/Low_Rise.jpg?width=150'
                },
                {
                    response: 'Mid-Rise',
                    link: '#Full_Seat_Showing_Woven_Mid_Rise',
                    image: '/images/PiperQuiz/Mid_Rise.jpg?width=150'
                },
                {
                    response: 'High-Rise',
                    link: '#Full_Seat_Showing_Woven_High_Rise',
                    image: '/images/PiperQuiz/High_Rise.jpg?width=150'
                }
                // {
                //     response: 'Curvy',
                //     link: '#Curvy_Full_Seat_Showing_Woven',
                //     image: '/images/PiperQuiz/High_Rise.jpg?width=150'
                // }
            ],
            productId: '',
            showSection: 'sectionName jsHide'
        },
        {
            name: 'Piper_Full_Seat_Showing_Woven_Low_Rise',
            response: 'Low-Rise',
            result: true,
            question: '',
            answer: [],
            productId: '23064',
            showSection: 'sectionName jsHide'
        },
        {
            name: 'Piper_Full_Seat_Showing_Woven_Mid_Rise',
            response: 'Mid-Rise',
            result: true,
            question: '',
            answer: [],
            productId: '24028',
            showSection: 'sectionName jsHide'
        },
        {
            name: 'Piper_Full_Seat_Showing_Woven_High_Rise',
            response: 'High-Rise',
            result: true,
            question: '',
            answer: [],
            productId: '24028!25578',
            showSection: 'sectionName jsHide'
        },
        // {
        //     name: 'Piper_Curvy_Full_Seat_Showing_Woven',
        // response: 'Curvy_Full_Seat_Showing_Woven',
        //     result: true,
        //     question: '',
        //     answer: [],
        //     productId: '24028',
        //     showSection: 'sectionName jsHide'
        // },
        {
            name: 'Piper_Full_Seat_Showing_Technical',
            response: 'Technical',
            result: false,
            question:
                'Do you prefer a low-rise fit that hits below the belly button, a mid-rise fit that hits at the belly button, or a high-rise fit that hits at the natural waist?',
            answer: [
                {
                    response: 'Low-Rise',
                    link: '#Full_Seat_Showing_Technical_Low_Rise',
                    image: '/images/PiperQuiz/Low_Rise.jpg?width=150'
                },
                {
                    response: 'Mid-Rise',
                    link: '#Full_Seat_Showing_Technical_Mid_Rise',
                    image: '/images/PiperQuiz/Mid_Rise.jpg?width=150'
                },
                {
                    response: 'High-Rise',
                    link: '#Full_Seat_Showing_Technical_High_Rise',
                    image: '/images/PiperQuiz/High_Rise.jpg?width=150'
                }
                // {
                //     response: 'Curvy',
                //     link: '#Curvy_Showing_Technical_Full_Seat',
                //     image: '/images/PiperQuiz/High_Rise.jpg?width=150'
                // }
            ],
            productId: '',
            showSection: 'sectionName jsHide'
        },
        {
            name: 'Piper_Full_Seat_Showing_Technical_Low_Rise',
            response: 'Low-Rise',
            result: true,
            question: '',
            answer: [],
            productId: '23064',
            showSection: 'sectionName jsHide'
        },
        {
            name: 'Piper_Full_Seat_Showing_Technical_Mid_Rise',
            response: 'Mid-Rise',
            result: true,
            question: '',
            answer: [],
            productId: '14690',
            showSection: 'sectionName jsHide'
        },
        {
            name: 'Piper_Full_Seat_Showing_Technical_High_Rise',
            response: 'High-Rise',
            result: true,
            question: '',
            answer: [],
            productId: '24028!25578',
            showSection: 'sectionName jsHide'
        },
        // {
        //     name: 'Piper_Curvy_Showing_Technical_Full_Seat',
        // response: 'Curvy_Showing_Technical_Full_Seat',
        //     result: true,
        //     question: '',
        //     answer: [],
        //     productId: '24028',
        //     showSection: 'sectionName jsHide'
        // },
        {
            name: 'Piper_Full_Seat_Schooling',
            response: 'Schooling',
            result: false,
            question:
                'Do you prefer the classic look and feel of a traditional woven material, the comfort of a stretchy knit, or the performance of a technical fabric?',
            answer: [
                {
                    response: 'Traditional Woven',
                    link: '#Full_Seat_Schooling_Woven',
                    image: '/images/PiperQuiz/answer_4b.jpg'
                },
                {
                    response: 'Stretchy Knit/Tight',
                    link: '#Full_Seat_Schooling_Knit',
                    image: '/images/PiperQuiz/answer_4a.jpg'
                },
                {
                    response: 'Technical',
                    link: '#Full_Seat_Schooling_Technical',
                    image: '/images/PiperQuiz/technical.jpg'
                }
            ],
            productId: '',
            showSection: 'sectionName jsHide'
        },
        {
            name: 'Piper_Full_Seat_Schooling_Knit',
            response: 'Knit',
            result: false,
            question:
                'Do you prefer a low-rise fit that hits below the belly button, or a mid-rise fit that hits at the belly button?',
            answer: [
                //                {
                //                    response: 'Low-Rise',
                //                    link: '#Full_Seat_Schooling_Knit_Low_Rise',
                //                    image: '/images/PiperQuiz/Low_Rise.jpg?width=150'
                //                },
                {
                    response: 'Mid-Rise',
                    link: '#Full_Seat_Schooling_Knit_Mid_Rise',
                    image: '/images/PiperQuiz/Mid_Rise.jpg?width=150'
                },
                {
                    response: 'High-Rise',
                    link: '#Full_Seat_Schooling_Knit_High_Rise',
                    image: '/images/PiperQuiz/High_Rise.jpg?width=150'
                }
            ],
            productId: '',
            showSection: 'sectionName jsHide'
        },
        //        {
        //            name: 'Piper_Full_Seat_Schooling_Knit_Low_Rise',
        //            response: 'Low-Rise',
        //            result: true,
        //            question: '',
        //            answer: [],
        //            productId: '24987',
        //            showSection: 'sectionName jsHide'
        //        },
        {
            name: 'Piper_Full_Seat_Schooling_Knit_Mid_Rise',
            response: 'Mid-Rise',
            result: true,
            question: '',
            answer: [],
            productId: '26120!26128!26107',
            showSection: 'sectionName jsHide'
        },
        {
            name: 'Piper_Full_Seat_Schooling_Knit_High_Rise',
            response: 'High-Rise',
            result: true,
            question: '',
            answer: [],
            productId: '26121',
            showSection: 'sectionName jsHide'
        },
        {
            name: 'Piper_Full_Seat_Schooling_Woven',
            response: 'Woven',
            result: false,
            question:
                'Do you prefer a low-rise fit that hits below the belly button, or a mid-rise fit that hits at the belly button?',
            answer: [
                {
                    response: 'Low-Rise',
                    link: '#Full_Seat_Schooling_Woven_Low_Rise',
                    image: '/images/PiperQuiz/Low_Rise.jpg?width=150'
                },
                {
                    response: 'Mid-Rise',
                    link: '#Full_Seat_Schooling_Woven_Mid_Rise',
                    image: '/images/PiperQuiz/Mid_Rise.jpg?width=150'
                },
                {
                    response: 'High-Rise',
                    link: '#Full_Seat_Schooling_Woven_High_Rise',
                    image: '/images/PiperQuiz/High_Rise.jpg?width=150'
                }
                // {
                //     response: 'Curvy',
                //     link: '#Curvy_Woven_Full_Seat',
                //     image: '/images/PiperQuiz/High_Rise.jpg?width=150'
                // }
            ],
            productId: '',
            showSection: 'sectionName jsHide'
        },
        {
            name: 'Piper_Full_Seat_Schooling_Woven_Mid_Rise',
            response: 'Mid-Rise',
            result: true,
            question: '',
            answer: [],
            productId: '14690',
            showSection: 'sectionName jsHide'
        },
        {
            name: 'Piper_Full_Seat_Schooling_Woven_High_Rise',
            response: 'High-Rise',
            result: true,
            question: '',
            answer: [],
            productId: '24028!25578!25567',
            showSection: 'sectionName jsHide'
        },
        // {
        //     name: 'Piper_Curvy_Woven_Full_Seat',
        //     result: true,
        //     question: '',
        //     answer: [],
        //     productId: '24028',
        //     showSection: 'sectionName jsHide'
        // },
        {
            name: 'Piper_Full_Seat_Schooling_Woven_Low_Rise',
            response: 'Low-Rise',
            result: true,
            question: '',
            answer: [],
            productId: '23064',
            showSection: 'sectionName jsHide'
        },
        {
            name: 'Piper_Full_Seat_Schooling_Technical',
            response: 'Technical',
            result: false,
            question:
                'Do you prefer a low-rise fit that hits below the belly button, a mid-rise fit that hits at the belly button, or a high-rise fit that hits at the natural waist?',
            answer: [
                {
                    response: 'Low-Rise',
                    link: '#Full_Seat_Schooling_Technical_Low_Rise',
                    image: '/images/PiperQuiz/Low_Rise.jpg?width=150'
                },
                {
                    response: 'Mid-Rise',
                    link: '#Full_Seat_Schooling_Technical_Mid_Rise',
                    image: '/images/PiperQuiz/Mid_Rise.jpg?width=150'
                },
                {
                    response: 'High-Rise',
                    link: '#Full_Seat_Schooling_Technical_High_Rise',
                    image: '/images/PiperQuiz/High_Rise.jpg?width=150'
                }
                // {
                //     response: 'Curvy',
                //     link: '#Curvy_Full_Seat_Schooling_Technical',
                //     image: '/images/PiperQuiz/High_Rise.jpg?width=150'
                // }
            ],
            productId: '',
            showSection: 'sectionName jsHide'
        },

        {
            name: 'Piper_Full_Seat_Schooling_Technical_Low_Rise',
            response: 'Low-Rise',
            result: true,
            question: '',
            answer: [],
            productId: '23064',
            showSection: 'sectionName jsHide'
        },

        {
            name: 'Piper_Full_Seat_Schooling_Technical_Mid_Rise',
            response: 'Mid-Rise',
            result: true,
            question: '',
            answer: [],
            productId: '14690',
            showSection: 'sectionName jsHide'
        },

        {
            name: 'Piper_Full_Seat_Schooling_Technical_High_Rise',
            response: 'High-Rise',
            result: true,
            question: '',
            answer: [],
            productId: '24028!25578',
            showSection: 'sectionName jsHide'
        },
        // {
        //     name: 'Piper_Curvy_Full_Seat_Schooling_Technical',
        // response: 'Curvy_Full_Seat_Schooling_Technical',
        //     result: true,
        //     question: '',
        //     answer: [],
        //     productId: '24028',
        //     showSection: 'sectionName jsHide'
        // },
        {
            name: 'Piper_Knee_Patch',
            response: 'Knee Patch',
            result: false,
            question: 'Are you looking for schooling breeches or showing breeches?',
            answer: [
                {
                    response: 'Schooling',
                    link: '#Knee_Patch_Schooling',
                    image: ''
                },
                {
                    response: 'Showing',
                    link: '#Knee_Patch_Showing',
                    image: ''
                }
            ],
            productId: '',
            showSection: 'sectionName jsHide'
        },
        {
            name: 'Piper_Knee_Patch_Showing',
            response: 'Showing',
            result: false,
            question:
                'Do you prefer the classic look and feel of a traditional woven material or the performance of a technical fabric?',
            answer: [
                {
                    response: 'Traditional Woven',
                    link: '#Knee_Patch_Showing_Woven',
                    image: '/images/PiperQuiz/answer_4b.jpg'
                },
                {
                    response: 'Technical',
                    link: '#Knee_Patch_Showing_Technical',
                    image: '/images/PiperQuiz/technical.jpg'
                }
            ],
            productId: '',
            showSection: 'sectionName jsHide'
        },
        {
            name: 'Piper_Knee_Patch_Showing_Woven',
            response: 'Woven',
            result: false,
            question:
                'Do you prefer a low-rise fit that hits below the belly button, a mid-rise fit that hits at the belly button, or a high-rise fit that hits at the natural waist?',
            answer: [
                {
                    response: 'Low-Rise',
                    link: '#Knee_Patch_Showing_Woven_Low_Rise',
                    image: '/images/PiperQuiz/Low_Rise.jpg?width=150'
                },
                //                {
                //                    response: 'Mid-Rise',
                //                    link: '#Knee_Patch_Showing_Woven_Mid_Rise',
                //                    image: '/images/PiperQuiz/Mid_Rise.jpg?width=150'
                //                },
                {
                    response: 'High-Rise',
                    link: '#Knee_Patch_Showing_Woven_High_Rise',
                    image: '/images/PiperQuiz/High_Rise.jpg?width=150'
                }
                // {
                //     response: 'Curvy',
                //     link: '#Curvy_Knee_Patch_Woven_Showing',
                //     image: '/images/PiperQuiz/High_Rise.jpg?width=150'
                // }
            ],
            productId: '',
            showSection: 'sectionName jsHide'
        },
        {
            name: 'Piper_Knee_Patch_Showing_Woven_Low_Rise',
            response: 'Low-Rise',
            result: true,
            question: '',
            answer: [],
            productId: '23063',
            showSection: 'sectionName jsHide'
        },
        //        {
        //            name: 'Piper_Knee_Patch_Showing_Woven_Mid_Rise',
        //            response: 'Mid-Rise',
        //            result: true,
        //            question: '',
        //            answer: [],
        //            productId: '24035!23430',
        //            showSection: 'sectionName jsHide'
        //        },
        {
            name: 'Piper_Knee_Patch_Showing_Woven_High_Rise',
            response: 'High-Rise',
            result: true,
            question: '',
            answer: [],
            productId: '24030!25579',
            showSection: 'sectionName jsHide'
        },
        // {
        //     name: 'Piper_Curvy_Knee_Patch_Woven_Showing',
        // response: 'Curvy_Knee_Patch_Woven_Showing',
        //     result: true,
        //     question: '',
        //     answer: [],
        //     productId: '24030',
        //     showSection: 'sectionName jsHide'
        // },
        {
            name: 'Piper_Knee_Patch_Showing_Technical',
            response: 'Technical',
            result: false,
            question:
                'Do you prefer a low-rise fit that hits below the belly button, a mid-rise fit that hits at the belly button, or a high-rise fit that hits at the natural waist?',
            answer: [
                {
                    response: 'Low-Rise',
                    link: '#Knee_Patch_Showing_Technical_Low_Rise',
                    image: '/images/PiperQuiz/Low_Rise.jpg?width=150'
                },
                {
                    response: 'Mid-Rise',
                    link: '#Knee_Patch_Showing_Technical_Mid_Rise',
                    image: '/images/PiperQuiz/Mid_Rise.jpg?width=150'
                },
                {
                    response: 'High-Rise',
                    link: '#Knee_Patch_Showing_Technical_High_Rise',
                    image: '/images/PiperQuiz/High_Rise.jpg?width=150'
                }
                // {
                //     response: 'Curvy',
                //     link: '#Curvy_Knee_Patch_Technical_Showing',
                //     image: '/images/PiperQuiz/High_Rise.jpg?width=150'
                // }
            ],
            productId: '',
            showSection: 'sectionName jsHide'
        },
        {
            name: 'Piper_Knee_Patch_Showing_Technical_Low_Rise',
            response: 'Low-Rise',
            result: true,
            question: '',
            answer: [],
            productId: '23063',
            showSection: 'sectionName jsHide'
        },
        {
            name: 'Piper_Knee_Patch_Showing_Technical_Mid_Rise',
            response: 'Mid-Rise',
            result: true,
            question: '',
            answer: [],
            productId: '14691!20517!23065',
            showSection: 'sectionName jsHide'
        },
        {
            name: 'Piper_Knee_Patch_Showing_Technical_High_Rise',
            response: 'High-Rise',
            result: true,
            question: '',
            answer: [],
            productId: '24030!25579',
            showSection: 'sectionName jsHide'
        },
        // {
        //     name: 'Piper_Curvy_Knee_Patch_Technical_Showing',
        // response: 'Curvy_Knee_Patch_Technical_Showing',
        //     result: true,
        //     question: '',
        //     answer: [],
        //     productId: '24030',
        //     showSection: 'sectionName jsHide'
        // },

        {
            name: 'Piper_Knee_Patch_Schooling',
            response: 'Schooling',
            result: false,
            question:
                'Do you prefer the classic look and feel of a traditional woven material, the comfort of a stretchy knit, or the performance of a technical fabric?',
            answer: [
                {
                    response: 'Traditional Woven',
                    link: '#Knee_Patch_Schooling_Woven',
                    image: '/images/PiperQuiz/answer_4b.jpg'
                },
                {
                    response: 'Stretchy Knit/Tight',
                    link: '#Knee_Patch_Schooling_Knit',
                    image: '/images/PiperQuiz/answer_4a.jpg'
                },
                {
                    response: 'Technical',
                    link: '#Knee_Patch_Schooling_Technical',
                    image: '/images/PiperQuiz/technical.jpg'
                }
            ],
            productId: '',
            showSection: 'sectionName jsHide'
        },
        {
            name: 'Piper_Knee_Patch_Schooling_Technical',
            response: 'Technical',
            result: false,
            question:
                'Do you prefer a low-rise fit that hits below the belly button, a mid-rise fit that hits at the belly button, or a high-rise fit that hits at the natural waist?',
            answer: [
                {
                    response: 'Low-Rise',
                    link: '#Knee_Patch_Schooling_Technical_Low_Rise',
                    image: '/images/PiperQuiz/Low_Rise.jpg?width=150'
                },
                {
                    response: 'Mid-Rise',
                    link: '#Knee_Patch_Schooling_Technical_Mid_Rise',
                    image: '/images/PiperQuiz/Mid_Rise.jpg?width=150'
                },
                {
                    response: 'High-Rise',
                    link: '#Knee_Patch_Schooling_Technical_High_Rise',
                    image: '/images/PiperQuiz/High_Rise.jpg?width=150'
                }
                // {
                //     response: 'Curvy',
                //     link: '#Curvy_Knee_Patch_Technical_Schooling',
                //     image: '/images/PiperQuiz/High_Rise.jpg?width=150'
                // }
            ],
            productId: '',
            showSection: 'sectionName jsHide'
        },
        {
            name: 'Piper_Knee_Patch_Schooling_Technical_Low_Rise',
            response: 'Low-Rise',
            result: true,
            question: '',
            answer: [],
            productId: '23063',
            showSection: 'sectionName jsHide'
        },
        {
            name: 'Piper_Knee_Patch_Schooling_Technical_Mid_Rise',
            response: 'Mid-Rise',
            result: true,
            question: '',
            answer: [],
            productId: '14691',
            showSection: 'sectionName jsHide'
        },
        {
            name: 'Piper_Knee_Patch_Schooling_Technical_High_Rise',
            response: 'High-Rise',
            result: true,
            question: '',
            answer: [],
            productId: '24030!25579',
            showSection: 'sectionName jsHide'
        },
        // {
        //     name: 'Piper_Curvy_Knee_Patch_Technical_Schooling',
        // response: 'Curvy_Knee_Patch_Technical_Schooling',
        //     result: true,
        //     question: '',
        //     answer: [],
        //     productId: '24030',
        //     showSection: 'sectionName jsHide'
        // },
        {
            name: 'Piper_Knee_Patch_Schooling_Knit',
            response: 'Knit',
            result: false,
            question:
                'Do you prefer a low-rise fit that hits below the belly button, or a mid-rise fit that hits at the belly button?',
            answer: [
                //                {
                //                    response: 'Low-Rise',
                //                    link: '#Knee_Patch_Schooling_Knit_Low_Rise',
                //                    image: '/images/PiperQuiz/Low_Rise.jpg?width=150'
                //                },
                {
                    response: 'Mid-Rise',
                    link: '#Knee_Patch_Schooling_Knit_Mid_Rise',
                    image: '/images/PiperQuiz/Mid_Rise.jpg?width=150'
                },
                {
                    response: 'High-Rise',
                    link: '#Knee_Patch_Schooling_Knit_High_Rise',
                    image: '/images/PiperQuiz/High_Rise.jpg?width=150'
                }
            ],
            productId: '',
            showSection: 'sectionName jsHide'
        },
        //        {
        //            name: 'Piper_Knee_Patch_Schooling_Knit_Low_Rise',
        //            response: 'Low-Rise',
        //            result: true,
        //            question: '',
        //            answer: [],
        //            productId: '24987',
        //            showSection: 'sectionName jsHide'
        //        },
        {
            name: 'Piper_Knee_Patch_Schooling_Knit_Mid_Rise',
            response: 'Mid-Rise',
            result: true,
            question: '',
            answer: [],
            productId: '26125!26129',
            showSection: 'sectionName jsHide'
        },
        {
            name: 'Piper_Knee_Patch_Schooling_Knit_High_Rise',
            response: 'High-Rise',
            result: true,
            question: '',
            answer: [],
            productId: '26126',
            showSection: 'sectionName jsHide'
        },
        {
            name: 'Piper_Knee_Patch_Schooling_Woven',
            response: 'Woven',
            result: false,
            question:
                'Do you prefer a low-rise fit that hits below the belly button, a mid-rise fit that hits at the belly button, or a high-rise fit that hits at the natural waist?',
            answer: [
                {
                    response: 'Low-Rise',
                    link: '#Knee_Patch_Schooling_Woven_Low_Rise',
                    image: '/images/PiperQuiz/Low_Rise.jpg?width=150'
                },
                {
                    response: 'Mid-Rise',
                    link: '#Knee_Patch_Schooling_Woven_Mid_Rise',
                    image: '/images/PiperQuiz/Mid_Rise.jpg?width=150'
                },
                {
                    response: 'High-Rise',
                    link: '#Knee_Patch_Schooling_Woven_High_Rise',
                    image: '/images/PiperQuiz/High_Rise.jpg?width=150'
                }
                // {
                //     response: 'Curvy',
                //     link: '#Curvy_Woven_Knee_Patch',
                //     image: '/images/PiperQuiz/High_Rise.jpg?width=150'
                // }
            ],
            productId: '',
            showSection: 'sectionName jsHide'
        },
        {
            name: 'Piper_Knee_Patch_Schooling_Woven_Mid_Rise',
            response: 'Mid-Rise',
            result: true,
            question: '',
            answer: [],
            productId: '14691!23065',
            showSection: 'sectionName jsHide'
        },
        {
            name: 'Piper_Knee_Patch_Schooling_Woven_High_Rise',
            response: 'High-Rise',
            result: true,
            question: '',
            answer: [],
            productId: '24030!25579!25568',
            showSection: 'sectionName jsHide'
        },
        // {
        //     name: 'Piper_Curvy_Woven_Knee_Patch',
        // response: 'Curvy_Woven_Knee_Patch',
        //     result: true,
        //     question: '',
        //     answer: [],
        //     productId: '24030',
        //     showSection: 'sectionName jsHide'
        // },
        {
            name: 'Piper_Knee_Patch_Schooling_Woven_Low_Rise',
            response: 'Low-Rise',
            result: true,
            question: '',
            answer: [],
            productId: '23063',
            showSection: 'sectionName jsHide'
        },
        {
            name: 'Piper_Boot_Cut',
            response: 'Boot_Cut',
            result: true,
            question: '',
            answer: [],
            productId: '26123!26124!26122',
            showSection: 'sectionName jsHide'
        }
    ]
};

ko.applyBindings(new PiperQuiz(data), document.getElementById('piperSections'));
